<div mat-dialog-content>
  <p [innerHTML]="message"></p>
  <div class="detail" [innerHTML]="messageDetail"></div>
  <ul>
    <li *ngFor="let item of details">{{ item }}</li>
  </ul>
</div>
<div mat-dialog-actions class="button-align">
  <button mat-button mat-dialog-close class="button_small cancel">
    cancel
  </button>
  <button mat-button class="button_small" (click)="onConfirmClick()">
    {{ actionButton }}
  </button>
</div>
